import { useQuery } from "@tanstack/react-query";
import type { EmissionRecordView } from "../../apiClient/generated";
import { useAdminApiClient, useAppSelector } from "../../hooks";

export const useCompanyDataForEmission = ({
    emissionRecord,
}: {
    emissionRecord?: EmissionRecordView;
}) => {
    const adminApiClient = useAdminApiClient();
    const currentUserCompany = useAppSelector((store) => store.auth.company);

    // If it's a superuser, fetch company settings for
    // the currently open company.
    const isSuperuser = useAppSelector((store) => store.auth.isStaff);
    const companyDataQuery = useQuery({
        queryKey: ["companyData", emissionRecord?.owner],
        queryFn: async () => {
            return await adminApiClient.adminAccountsCompaniesRetrieve({
                id: emissionRecord.owner,
            });
        },
        refetchOnWindowFocus: false,
        enabled: isSuperuser && !!emissionRecord,
        staleTime: 0,
    });

    return {
        isLoading: isSuperuser ? companyDataQuery.isLoading : false,
        company: isSuperuser ? companyDataQuery.data : currentUserCompany,
    };
};
